import { zeroErrorMessage } from "@/lib/zero-error";
import { useQuery as useZeroQuery } from "@rocicorp/zero/react";
import { appQueries } from "@production-hub/shared";
import { useMemo } from "react";
import { useProjects } from "@/hooks/useProjects";

const EMPTY_UUID = "00000000-0000-0000-0000-000000000000";

type ZeroAssignmentRow = {
  group?: {
    projectID: string;
  } | null;
};

export function useEquipmentProjects(equipmentId: string | undefined) {
  const query = equipmentId
    ? appQueries.equipmentConflicts.assignmentsByEquipment({
        equipmentIDs: [equipmentId],
      })
    : appQueries.equipmentConflicts.assignmentsByEquipment({
        equipmentIDs: [EMPTY_UUID],
      });
  const [assignments, details] = useZeroQuery(query, {
    enabled: !!equipmentId,
  });
  const { data: projects = [] } = useProjects(false);

  const data = useMemo(() => {
    const projectIds = new Set(
      ((assignments ?? []) as ZeroAssignmentRow[])
        .map((assignment) => assignment.group?.projectID)
        .filter(Boolean),
    );

    return projects
      .filter((project) => projectIds.has(project.id))
      .sort((a, b) =>
        (b.event_start_date ?? "").localeCompare(a.event_start_date ?? ""),
      );
  }, [assignments, projects]);

  return {
    data,
    isLoading:
      !!equipmentId && details.type !== "complete" && data.length === 0,
    isFetching: !!equipmentId && details.type !== "complete",
    isError: details.type === "error",
    error:
      details.type === "error"
        ? new Error(zeroErrorMessage(details.error))
        : null,
  };
}
